import { component } from 'picoapp';
import '@/lib/jquery-global.js';

export default component(( node, ctx ) => {

    const t = node.querySelector('.js-text')
    const url = t.dataset.title + ' ' + t.dataset.url;

    const content = node.querySelector('.js-content').textContent;

    // console.log(content);
    // console.log(node.querySelector('.js-content').innerHTML)


    t.addEventListener('click', function(e) {
        e.preventDefault();

        const num = node.querySelector('.js-input').value;        

        jQuery.ajax({
            type: 'post',
            data: { num: num, url: content },
            url: 'https://frozen-falls-16081.herokuapp.com/',
            success: function (data) {

                const num_form = node

                console.log(data.status);

                if (data.status == 400) {

                    num_form.classList.add('sms-error');

                    setTimeout(() => {
                        num_form.classList.remove('sms-error');
                    }, 2000);

                } else {

                    num_form.classList.add('sms-sent');
                    node.querySelector('.js-input').value = '';

                    setTimeout(() => {
                        num_form.classList.remove('sms-sent');
                    }, 2000);

                }

                
                
            }
         });    

    });


})
